exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.counters[data-v-0b1da424] {\n  display: -ms-flexbox;\n  display: flex;\n  background: #fbfcfc;\n  border: 1px solid #DBDFE2;\n  border-top: 0;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.counters > li[data-v-0b1da424] {\n    text-align: center;\n    padding: 1rem;\n    border-left: 1px solid #DBDFE2;\n}\n.counters > li[data-v-0b1da424]:first-child {\n      border-left: 0;\n}\n.counters > li h6[data-v-0b1da424] {\n      color: #8ca0b3;\n}\n.counters .calculator[data-v-0b1da424] {\n    margin-top: 1rem;\n    font-size: 1.15rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0b1da424","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/PriceCounters.vue
// module id = 1695
// module chunks = 0